export const footerTestId = {
  footer: 'footer_component',
  link: 'footer_link',
  sectionTitle: 'footer_sectionTitle',
  sectionTitleIcon: 'footer_sectionIcon',
  footerQrCode: 'footer_qrCode',
  footerSocialLink: 'footer_socialLink',
  footerCopyright: 'footer_copyright',
};
